import { PaginatedListResponse } from "@/domain/dto/BaseDataResponse";
import { CreateQuestionaireDTO } from "@/domain/dto/CreateQuestionaireDTO";
import { ListQuestionairesQueryParamsDTO } from "@/domain/dto/ListQuestionairesQueryParamsDTO";
import { Questionaire } from "@/domain/entities/Questionaire";
import { IQuestionaireRepository } from "@/domain/repositories/IQuestionaireRepository";
import { IQuestionaireRemoteDataSource } from "../datasources/interfaces/remote/IQuestionaireRemoteDataSource";
import QuestionaireMappers from "../mappers/QuestionaireDataMappers";
import ResponseDataMappers from "../mappers/ResponseDataMappers";
import { UpdateQuestionaireDTO } from "@/domain/dto/UpdateQuestionaireDTO";

export class QuestionaireRepository implements IQuestionaireRepository {
    dataSource: IQuestionaireRemoteDataSource
    constructor(dataSource: IQuestionaireRemoteDataSource) {
        this.dataSource = dataSource
    }

    async create(params: CreateQuestionaireDTO): Promise<Questionaire> {
        const response = await this.dataSource.create(params)
        return QuestionaireMappers.toEntity(response.data)
    }

    async list(params: ListQuestionairesQueryParamsDTO): Promise<PaginatedListResponse<Questionaire>> {
        const response = await this.dataSource.list(params)
        return ResponseDataMappers.toPaginatedListResponse(response, response.data.map(QuestionaireMappers.toEntity))
    }

    async show(id: string): Promise<Questionaire> {
        const response = await this.dataSource.show(id)
        return QuestionaireMappers.toEntity(response.data)
    }
    update(id: string, params: UpdateQuestionaireDTO): Promise<void> {
        return this.dataSource.update(id, params)
    }
}
